import React from 'react';
import { isMobile } from 'react-device-detect';

function Sections(props) {
  const { title, description, points, media, className, showUptillText } = props;
  return (
    <section className={`contents ${className}`}>
      <article>
        {showUptillText && !isMobile && <div className='uptillText'>uptill now</div>}
        <h1>{title}... {showUptillText && isMobile && <span className='uptillTextMobile'>uptill now</span>}</h1>
        <p>{description}</p>
        <ul>
          {points.map((items, index) => {
            return (
              <li key={index}>
                <span className='bullets' />
                <span>{items.title}</span>
              </li>
            );
          })}
        </ul>
      </article>
      <figure>
        <img src={media} alt='' style={{ width: '100%' }} />
      </figure>
    </section>
  );
}

export default Sections;
